export const ADD_LEADS = "ADD_LEADS";
export const LOGIN_REQUEST = {type: "LOGIN_REQUEST"};
export const REGISTER_SUCCESS = {type: "REGISTER_SUCCESS"};
export const SET_USER = {type: "LOGIN_SUCCESS"};